export const theme_bod = {
  link: "#2C2D84",
  linkHover: "#1f205e",
  linkActive: "#131338",

  linkBackground: "rgba(44, 45, 132, 0.1)",

  textBackground: "rgba(33, 33, 33, 0.1)",

  text: "#212121",
  grey: "#343434",
  pale: "#f7f6f2",
  offwhite: "#cecece",
  white: "#ffffff",

  grey2: "#999999",

  cardShadow: "rgba(225,223,210, 0.6)",
  toggleColor: "rgba(44,45,132,0.6)", //rgb of link

  green: "#9fc63b",
  focus: "#FFB81C",
  error: "#d51010",

  darkGreen: "#29330F",
  darkYellow: "#413402",

  maxWidth: "1000px",
  outerSpacing: "20px",
  breakpointS: "350px",
  breakpointM: "750px",
  breakpointL: "1000px",

  primary: "#9fc63b",
  primaryCompanion: "#80a02e",
  primaryText: "#3c3c3b",
  primaryHover: "#96bb36",
  primaryHoverText: "#3c3c3b",
}
